// extracted by mini-css-extract-plugin
module.exports = {"root":"ApplicationValues_root_3_7ri","title":"ApplicationValues_title_1Lcae","control":"ApplicationValues_control_IDOXu","hint":"ApplicationValues_hint_31xHq"};